import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import LoadingScreen from './components/LoadingScreen';
import HelpPrompt from './components/HelpPrompt';
import InterfaceUI from './components/InterfaceUI';
import eventBus from './EventBus';
import './style.css';
const App = () => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        eventBus.on('loadingScreenDone', () => {
            setLoading(false);
        });
    }, []);
    return (_jsxs("div", Object.assign({ id: "ui-app" }, { children: [!loading && _jsx(HelpPrompt, {}), _jsx(LoadingScreen, {})] })));
};
const createUI = () => {
    ReactDOM.render(_jsx(App, {}), document.getElementById('ui'));
};
const createVolumeUI = () => {
    ReactDOM.render(_jsx(InterfaceUI, {}), document.getElementById('ui-interactive'));
};
export { createUI, createVolumeUI };
